import { useState, type FormEvent } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import api, { ApiError } from '../lib/apiClient';
import { usePublicBranding } from '../hooks/usePublicBranding';
import vnpfLogo from '../assets/vnpf-logo.png';
import './Login.css';

export function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') ?? '';
  const email = searchParams.get('email') ?? '';
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [errors, setErrors] = useState<Record<string, string[]>>({});
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const branding = usePublicBranding();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setErrors({});
    setLoading(true);
    try {
      await api.post('/reset-password', {
        token,
        email,
        password,
        password_confirmation: passwordConfirmation,
      });
      setDone(true);
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      if (err instanceof ApiError && err.errors) {
        setErrors(err.errors);
      } else {
        setErrors({ general: [err instanceof ApiError ? err.message : 'Something went wrong.'] });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <img src={branding.app_icon_url ?? vnpfLogo} alt="" className="brand-mark-lg" />
        <h1>{branding.app_name}</h1>
        <p className="muted">Choose a new password</p>

        {!token || !email ? (
          <div className="alert alert-error">
            This reset link is invalid or incomplete. Please request a new one.
          </div>
        ) : done ? (
          <div className="alert alert-success">Password reset. Redirecting to sign in…</div>
        ) : (
          <form onSubmit={handleSubmit}>
            {errors.general && <div className="alert alert-error">{errors.general[0]}</div>}
            {errors.email && <div className="alert alert-error">{errors.email[0]}</div>}
            <label>
              Email
              <input type="email" value={email} disabled />
            </label>
            <label>
              New password
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={8}
                autoFocus
              />
              {errors.password && <small className="error">{errors.password[0]}</small>}
            </label>
            <label>
              Confirm new password
              <input
                type="password"
                value={passwordConfirmation}
                onChange={(e) => setPasswordConfirmation(e.target.value)}
                required
                minLength={8}
              />
            </label>
            <button className="btn btn-primary" disabled={loading}>
              {loading ? 'Resetting…' : 'Reset password'}
            </button>
          </form>
        )}

        <Link to="/login" className="login-secondary-link">
          Back to sign in
        </Link>
      </div>
    </div>
  );
}
